import { render, staticRenderFns } from "./AssumptionsResidentialNewOverall.vue?vue&type=template&id=17352e5a&"
import script from "./AssumptionsResidentialNewOverall.vue?vue&type=script&lang=js&"
export * from "./AssumptionsResidentialNewOverall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports